import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 5px;
  background: var(--black-400);
  margin-right: 0.8rem;
  margin-top: 0.8rem;

  width: 100%;

  p {
    font-size: 0.9rem;
  }

  button {
    background-color: var(--black-300);
    padding: 0rem;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.4s;

    &:hover {
      background-color: var(--black-100);
    }

    svg {
      width: 20px;
      height: 20px;

      path {
        stroke-width: 3px;
        stroke: var(--white);
      }
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0.8rem;
  border-bottom: 1px solid #3d3d3d;

  span {
    &:first-child {
      color: var(--grey-100);
      font-family: Inter, sans-serif;
      font-size: 0.9rem;
    }

    &:last-child {
      font-weight: 500;
      font-family: DM Sans, sans-serif;
    }
  }

  &:last-child {
    border-bottom: 0px;
  }
`;
